import { render, staticRenderFns } from "./ModalCustomize.vue?vue&type=template&id=10325a52&"
import script from "./ModalCustomize.vue?vue&type=script&lang=js&"
export * from "./ModalCustomize.vue?vue&type=script&lang=js&"
import style0 from "./ModalCustomize.vue?vue&type=style&index=0&id=10325a52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports